export default __webpack_public_path__ + "static/affiliate-handshake-e853913ed1114bb2c03fda840ce8137d.svg";